<template>
  <v-flex class="pa-4" data-qa="contactus-flex-wbu1op">
    {{'Contact Us'}}
  </v-flex>
</template>

<script>

export default {
  name: 'ContactUs'
}
</script>
